module.exports = __webpack_public_path__ + "images/花筑pr长图_02视频.jpg?v=977968c0";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_02视频.jpg
 ** module id = 12
 ** module chunks = 1 2
 **/